module.exports = __webpack_public_path__ + "media/images/blue-folder-hi-f43b9b04559e4957850b29543b1a2e7e.png";